(async () => {
  const layer = "dataLayer";
  let script_is_put = false;
  let user_is_sendable;
  let userToken = null;

  function push_to_dataLayer(data) {
    if (!!window.gtm_debug) console.log("GTM DEBUG", data);
    window[layer].push(data);
  }

  function md5(inputString) {
    const hc = "0123456789abcdef";

    function rh(n) {
      let j,
        s = "";
      for (j = 0; j <= 3; j++)
        s +=
          hc.charAt((n >> (j * 8 + 4)) & 0x0f) +
          hc.charAt((n >> (j * 8)) & 0x0f);
      return s;
    }

    function ad(x, y) {
      const l = (x & 0xffff) + (y & 0xffff);
      const m = (x >> 16) + (y >> 16) + (l >> 16);
      return (m << 16) | (l & 0xffff);
    }

    function rl(n, c) {
      return (n << c) | (n >>> (32 - c));
    }

    function cm(q, a, b, x, s, t) {
      return ad(rl(ad(ad(a, q), ad(x, t)), s), b);
    }

    function ff(a, b, c, d, x, s, t) {
      return cm((b & c) | (~b & d), a, b, x, s, t);
    }

    function gg(a, b, c, d, x, s, t) {
      return cm((b & d) | (c & ~d), a, b, x, s, t);
    }

    function hh(a, b, c, d, x, s, t) {
      return cm(b ^ c ^ d, a, b, x, s, t);
    }

    function ii(a, b, c, d, x, s, t) {
      return cm(c ^ (b | ~d), a, b, x, s, t);
    }

    function sb(x) {
      let i;
      const nblk = ((x.length + 8) >> 6) + 1;
      const blks = new Array(nblk * 16);
      for (i = 0; i < nblk * 16; i++) blks[i] = 0;
      for (i = 0; i < x.length; i++)
        blks[i >> 2] |= x.charCodeAt(i) << ((i % 4) * 8);
      blks[i >> 2] |= 0x80 << ((i % 4) * 8);
      blks[nblk * 16 - 2] = x.length * 8;
      return blks;
    }

    let i,
      x = sb("" + inputString),
      a = 1732584193,
      b = -271733879,
      c = -1732584194,
      d = 271733878,
      olda,
      oldb,
      oldc,
      oldd;
    for (i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;
      a = ff(a, b, c, d, x[i + 0], 7, -680876936);
      d = ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = ff(c, d, a, b, x[i + 10], 17, -42063);
      b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
      a = gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = gg(b, c, d, a, x[i + 0], 20, -373897302);
      a = gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
      a = hh(a, b, c, d, x[i + 5], 4, -378558);
      d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = hh(d, a, b, c, x[i + 0], 11, -358537222);
      c = hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = hh(b, c, d, a, x[i + 2], 23, -995338651);
      a = ii(a, b, c, d, x[i + 0], 6, -198630844);
      d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = ii(b, c, d, a, x[i + 9], 21, -343485551);
      a = ad(a, olda);
      b = ad(b, oldb);
      c = ad(c, oldc);
      d = ad(d, oldd);
    }
    return rh(a) + rh(b) + rh(c) + rh(d);
  }

  const hashValue = (val) =>
    crypto.subtle
      .digest("SHA-256", new TextEncoder("utf-8").encode(val))
      .then((h) => {
        let hexes = [],
          view = new DataView(h);
        for (let i = 0; i < view.byteLength; i += 4)
          hexes.push(("00000000" + view.getUint32(i).toString(16)).slice(-8));
        return hexes.join("");
      });

  //Initialize GTM tag
  async function launchGTM(checkout) {
    if (script_is_put) return true;

    user_is_sendable =
      (await browser.cookie.get("gtm_user_is_sendable")) === "true";

    userToken = (await browser.cookie.get("user_token")) || null;

    const root =
      window.tagUrl || "https://www.googletagmanager.com/gtm.js?id=#tag_id#";

    const { location, title } = init?.context?.document || {};
    window[layer] = window[layer] || [];

    push_to_dataLayer({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    const gtm_tag_ids = await browser.cookie.get("gtm_tag_ids");

    const gtm_tags = gtm_tag_ids.split(/\s?,\s?/);

    const {
      marketingAllowed,
      analyticsProcessingAllowed,
      preferencesProcessingAllowed,
    } = init?.customerPrivacy || {};

    const consent = {
      ad_storage: marketingAllowed ? "granted" : "denied",
      analytics_storage: analyticsProcessingAllowed ? "granted" : "denied",
      ad_user_data: analyticsProcessingAllowed ? "granted" : "denied",
      ad_personalization: preferencesProcessingAllowed ? "granted" : "denied",
      functionality_storage: "granted",
      personalization_storage: preferencesProcessingAllowed
        ? "granted"
        : "denied",
      security_storage: "granted",
      wait_for_update: 500,
    };

    push_to_dataLayer(
      (function () {
        return arguments;
      })("consent", "default", consent)
    );

    const infos = await get_general_infos(checkout);

    const { source, medium, campaign } = infos?.env || {};

    const pagePath = location.href.replace(
      /\/checkouts\/cn\/.*$/,
      "/checkouts/"
    );
    const initLayer = {
      event: "page_view",
      pagePath,
      pageTitle: title,
      pageType: "checkout",
      ...infos,
      source,
      medium,
      campaign,
    };

    push_to_dataLayer(initLayer);

    send_general_infos(infos);

    push_to_dataLayer({
      event: "consent-ready",
      consent,
    });

    const f = document.getElementsByTagName("script")[0];

    gtm_tags.forEach((tag_id) => {
      const j = document.createElement("script");
      const dl = layer != "dataLayer" ? "&l=" + layer : "";
      j.async = true;
      if (/#\s*tag_id\s*#/i.test(root))
        j.src = root.replace(/#\s*tag_id\s*#/i, tag_id);
      else j.src = root + tag_id;
      j.src = j.src + dl;

      f.parentNode.insertBefore(j, f);
    });

    script_is_put = true;
    return false;
  }

  function launchStorefrontGTM({ tag_url, gtm_tags = [] } = {}) {
    if (script_is_put) return true;
    script_is_put = true;
    window[layer] = window[layer] || [];

    push_to_dataLayer({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    push_to_dataLayer(
      (function () {
        return arguments;
      })("set", "url_passthrough", true)
    );

    const root =
      tag_url || "https://www.googletagmanager.com/gtm.js?id=#tag_id#";

    const f = document.getElementsByTagName("script")[0];
    const gtm_tag_ids = gtm_tags.split(/\s?,\s?/);

    gtm_tag_ids.forEach((tag_id) => {
      const j = document.createElement("script");
      const dl = layer != "dataLayer" ? "&l=" + layer : "";
      j.async = true;
      if (/#\s*tag_id\s*#/i.test(root))
        j.src = root.replace(/#\s*tag_id\s*#/i, tag_id);
      else j.src = root + tag_id;
      j.src = j.src + dl;

      f.parentNode.insertBefore(j, f);
    });

    return false;
  }

  // Étape 1. Initialisez le SDK du pixel JavaScript (pensez à exclure le code HTML)

  const getCheckoutItems = (items) => {
    return items.map((item, index) => {
      const {
        quantity,
        variant,
        title,
        discountAllocations,
        url: item_url,
      } = item;
      const {
        id,
        price,
        title: item_variant,
        sku: item_sku,
        product,
        image,
      } = variant;
      const discount = discountAllocations.reduce((total, current) => {
        total += current?.discountApplication?.value?.amount;
        return total;
      }, 0);

      return {
        item_id: id,
        item_name: title,
        coupon: "",
        discount,
        index,
        item_brand: product.vendor,
        item_category: product.type,
        item_list_id: "checkout",
        item_list_name: "checkout",
        item_variant,
        item_sku,
        item_image: image && image.src,
        item_url: product.url,
        price: price.amount,
        quantity,
      };
    });
  };

  const send_general_infos = (infos) => {
    const hasUser = window[layer].find(({ user_id }) => !!user_id);
    const hasEnv = window[layer].find(({ event }) => event === "env");

    if (!hasUser && infos.user_data) push_to_dataLayer(infos.user_data);
    if (!hasEnv && infos.env) push_to_dataLayer(infos.env);
  };

  const get_general_infos = async (checkout) => {
    const {
      email,
      id,
      ordersCount = 0,
      firstName,
      lastName,
    } = init?.data?.customer || {};

    const toReturn = {};

    toReturn.user_data = {
      user_id: id ? await hashValue(id) : null,
      user_email: user_is_sendable ? email : null,
      new_customer: ordersCount === 0,
      orders_count: ordersCount,
      first_name: user_is_sendable ? firstName : null,
      last_name: user_is_sendable ? lastName : null,
      user_name_sha256:
        firstName && lastName
          ? await hashValue(`${firstName} ${lastName}`)
          : null,
      user_email_sha256: email ? await hashValue(email) : null,
      user_email_md5: email ? md5(email) : null,
      email_optin_status: checkout?.buyerAcceptsEmailMarketing,
      sms_optin_status: checkout?.buyerAcceptsSmsMarketing,
      session_id: userToken,
      city: user_is_sendable ? checkout.billingAddress?.city || "" : null,
      country: user_is_sendable
        ? checkout.shippingAddress?.country ||
          checkout.billingAddress?.country ||
          ""
        : null,
      country_code: user_is_sendable
        ? checkout.shippingAddress?.countryCode ||
          checkout.billingAddress?.countryCode ||
          ""
        : null,
      zip: user_is_sendable
        ? checkout.shippingAddress?.zip || checkout.billingAddress?.zip || ""
        : null,
      province: user_is_sendable
        ? checkout.shippingAddress?.province ||
          checkout.billingAddress?.province ||
          ""
        : null,
      address1: user_is_sendable
        ? checkout.shippingAddress?.address1 ||
          checkout.billingAddress?.address1 ||
          ""
        : null,
      address2: user_is_sendable
        ? checkout.shippingAddress?.address1
          ? checkout.shippingAddress?.address2 || ""
          : checkout.billingAddress?.address2 || ""
        : null,
      phone: user_is_sendable
        ? checkout.phone || checkout.billingAddress?.phone || ""
        : null,
    };

    const previous_origin = await browser.sessionStorage.getItem("_vdjs_raw");
    const visit = {};
    if (previous_origin) {
      try {
        const origin = JSON.parse(atob(previous_origin));

        const visitData = origin.utm_tags ||
          origin.paid_url_data ||
          origin.organic_search_data ||
          origin.referral_data || {
            source: "(direct)",
            medium: "(none)",
            campaign: "(not set)",
          };

        visit.source = visitData.source;
        visit.medium = visitData.medium;
        visit.campaign = visitData.campaign;
      } catch (e) {}
    }

    toReturn.env = {
      event: "env",
      country: window?.init?.data?.shop?.countryCode.toLowerCase(),
      langage: window?.init?.data?.shop?.countryCode.toLowerCase(), // not available
      site_name: window?.init?.data?.shop?.myshopifyDomain,
      currency: window?.init?.data?.shop?.paymentSettings?.currencyCode,
      ...visit,
    };

    toReturn.session_id =
      userToken || (await browser.cookie.get("user_token")) || null;

    return toReturn;
  };

  const send_Step = (step, step_name) => {
    push_to_dataLayer({
      event: "checkout_step",
      step,
      step_name,
    });
  };

  const calculateSum = (ar) => {
    return ar.reduce((total, current) => {
      total += current;
      return total;
    }, 0);
  };

  const getTaxRate = (c) => {
    return c.totalTax.amount > 0
      ? parseFloat(
          (
            c.totalTax.amount /
            (c.totalPrice.amount - c.totalTax.amount)
          ).toFixed(2)
        )
      : 0;
  };

  const getSubTotalHt = (items, tax_rate = 0) => {
    const total_init_price = calculateSum(
      items.map((item) => item.price * item.quantity)
    );
    const total_discount = calculateSum(items.map((item) => item.discount));
    return parseFloat(
      ((total_init_price - total_discount) / (1 + tax_rate)).toFixed(2)
    );
  };

  // only for checkout extensibility or non shopify + sites
  analytics.subscribe("checkout_started", async (event) => {
    await launchGTM(event.data.checkout);
    const infos = await get_general_infos(event.data.checkout);
    send_Step(1, "begin_checkout");
    const evt = {
      event: "begin_checkout",
      ecommerce: {
        currency: event.data.checkout.currencyCode,
        timestamp: event.timestamp,
        token: event.data.checkout.token,
        shopify_client_id: event.clientId,
        email: event.data.checkout.email,
        value: event.data.checkout.subtotalPrice.amount,
        items: getCheckoutItems(event.data.checkout.lineItems),
      },
      ...infos,
    };
    push_to_dataLayer(evt);
  });

  analytics.subscribe("checkout_completed", async (event) => {
    const alreadySent = await launchGTM(event.data.checkout);
    send_Step(5, "checkout_completed");
    const infos = await get_general_infos(event.data.checkout);
    const taxRate = getTaxRate(event.data.checkout);
    const lineItems = getCheckoutItems(event.data.checkout.lineItems);
    if (alreadySent) {
      send_general_infos(infos);
    }
    const evt = {
      event: "purchase",
      ecommerce: {
        currency: event.data.checkout.currencyCode,
        transaction_id: event.data.checkout.order.id,
        token: event.data.checkout.token,
        timestamp: event.timestamp,
        value: event.data.checkout.subtotalPrice.amount,
        coupon: "",
        tax: event.data.checkout.totalTax.amount,
        shipping: event.data.checkout.shippingLine.price.amount,
        shopify_client_id: event.clientId,
        email: user_is_sendable ? event.data.checkout.email : null,
        email_sha256: await hashValue(event.data.checkout.email),
        email_md5: md5(event.data.checkout.email),
        sub_total: event.data.checkout.subtotalPrice.amount,
        sub_total_ht: getSubTotalHt(lineItems, taxRate),
        grand_total: event.data.checkout.totalPrice.amount,
        country: event.data.checkout.shippingAddress.country,
        country_code: event.data.checkout.shippingAddress.countryCode,
        zip: event.data.checkout.shippingAddress.zip,
        payment_type: event.data.checkout?.transactions[0]?.gateway || "",
        shipping_tier:
          event.data.checkout?.delivery?.selectedDeliveryOptions[0]?.title ||
          "",
        items: lineItems,
      },
      ...infos,
    };
    push_to_dataLayer(evt);
  });

  analytics.subscribe("payment_info_submitted", async (event) => {
    await launchGTM(event.data.checkout);
    const infos = await get_general_infos(event.data.checkout);
    send_Step(4, "add_payment_info");
    const evt = {
      event: "add_payment_info",
      ecommerce: {
        currency: event.data.checkout.currencyCode,
        timestamp: event.timestamp,
        token: event.data.checkout.token,
        shopify_client_id: event.clientId,
        email: event.data.checkout.email,
        value: event.data.checkout.subtotalPrice.amount,
        country: event.data.checkout.shippingAddress.country,
        country_code: event.data.checkout.shippingAddress.countryCode,
        zip: event.data.checkout.shippingAddress.zip,
        payment_type: event.data.checkout?.transactions[0]?.gateway || "",
        shipping_tier:
          event.data.checkout?.delivery?.selectedDeliveryOptions[0]?.title ||
          "",
        items: getCheckoutItems(event.data.checkout.lineItems),
      },
      ...infos,
    };
    push_to_dataLayer(evt);
  });

  analytics.subscribe("checkout_shipping_info_submitted", async (event) => {
    await launchGTM(event.data.checkout);
    send_Step(3, "add_shipping_info");
    const infos = await get_general_infos(event.data.checkout);
    const evt = {
      event: "add_shipping_info",
      ecommerce: {
        currency: event.data.checkout.currencyCode,
        timestamp: event.timestamp,
        token: event.data.checkout.token,
        shopify_client_id: event.clientId,
        email: event.data.checkout.email,
        value: event.data.checkout.subtotalPrice.amount,
        country: event.data.checkout.shippingAddress.country,
        country_code: event.data.checkout.shippingAddress.countryCode,
        zip: event.data.checkout.shippingAddress.zip,
        shipping_tier:
          event.data.checkout?.delivery?.selectedDeliveryOptions[0]?.title ||
          "",
        shipping: event.data.checkout.shippingLine.price.amount,
        items: getCheckoutItems(event.data.checkout.lineItems),
      },
      ...infos,
    };
    push_to_dataLayer(evt);
  });

  analytics.subscribe("checkout_address_info_submitted", async (event) => {
    await launchGTM(event.data.checkout);
    // relaunch email in case of log-in
    send_Step(2, "add_address_info");
    const infos = await get_general_infos(event.data.checkout);
    const evt = {
      event: "add_address_info",
      ecommerce: {
        currency: event.data.checkout.currencyCode,
        timestamp: event.timestamp,
        token: event.data.checkout.token,
        email: event.data.checkout.email,
        phone: event.data.checkout.phone,
        first_name: event.data.checkout.shippingAddress.firstName,
        last_name: event.data.checkout.shippingAddress.lastName,
        address1: event.data.checkout.shippingAddress.address1,
        address2: event.data.checkout.shippingAddress.address2,
        city: event.data.checkout.shippingAddress.city,
        country: event.data.checkout.shippingAddress.country,
        country_code: event.data.checkout.shippingAddress.countryCode,
        province: event.data.checkout.shippingAddress.province,
        province_code: event.data.checkout.shippingAddress.provinceCode,
        value: event.data.checkout.subtotalPrice.amount,
        items: getCheckoutItems(event.data.checkout.lineItems),
      },
      ...infos,
    };
    push_to_dataLayer(evt);
  });

  function pushDataFromEvent(event) {
    window[layer] = window[layer] || [];
    if (event.customData.is_arguments) {
      push_to_dataLayer(
        (function () {
          return arguments;
        })(...event.customData.arguments_data)
      );
    } else {
      push_to_dataLayer(event.customData.data);
    }
  }

  analytics.subscribe("TOZ_custom", (event) => {
    if (event.customData.throw_tag === false) {
      pushDataFromEvent(event);
    } else {
      launchStorefrontGTM({
        tag_url: event.customData.tag_url,
        gtm_tags: event.customData.gtm_tags,
      });

      pushDataFromEvent(event);
    }
  });

  /* Exemple de message remontant du pixel vers le storefront
  analytics.subscribe("search_submitted", (event) => {
    const evt = {
      event: "search",
      search_term : event.searchResult.query,
    };

    window.parent.postMessage(evt, window.location.origin);
  });

   */
})();
